import { MultiDepthTab } from "@/shared/lib/navigation/navigation.types"

export enum AccountQueryKeysEnum {
  FetchIp = "fetchIp",
  FetchAccount = "fetchAccount",
  FetchUserInfo = "fetchUserInfo",
  FetchContractInfo = "fetchContractInfo",
  FetchSubscriptionInfo = "fetchSubscriptionInfo",
  FetchBillingInfo = "fetchBillingInfo",
  FetchNextTierInfo = "fetchNextTierInfo",
  FetchCountryCode = "fetchCountryCode",
  FetchCustomPlanInfo = "fetchCustomPlanInfo",
}

export const CUSTOM_PLAN_PAGE_SIZE = 50

export const SETTING_PAGE_MENU_KO: MultiDepthTab[] = [
  {
    href: "/settings/account",
    subItems: [{ name: "계정", href: "/settings/account" }],
  },
  {
    href: "/settings/billing",
    subItems: [{ name: "청구서", href: "/settings/billing" }],
  },
  {
    href: "/settings/usage",
    subItems: [{ name: "사용량", href: "/settings/usage" }],
  },
  {
    href: "/settings/integrations",
    subItems: [{ name: "외부 플랫폼 연결", href: "/settings/integrations" }],
  },
]

export const SETTING_PAGE_MENU_EN: MultiDepthTab[] = [
  {
    href: "/settings/account",
    subItems: [{ name: "Accounts", href: "/settings/account" }],
  },
  {
    href: "/settings/billing",
    subItems: [{ name: "Invoices", href: "/settings/billing" }],
  },
  {
    href: "/settings/usage",
    subItems: [{ name: "Usage", href: "/settings/usage" }],
  },
  {
    href: "/settings/integrations",
    subItems: [
      { name: "External platform connections", href: "/settings/integrations" },
    ],
  },
]

export const SETTING_PAGE_MENU_JA: MultiDepthTab[] = [
  {
    href: "/settings/account",
    subItems: [{ name: "Accounts", href: "/settings/account" }],
  },
  {
    href: "/settings/billing",
    subItems: [{ name: "請求書", href: "/settings/billing" }],
  },
  {
    href: "/settings/usage",
    subItems: [{ name: "使用量", href: "/settings/usage" }],
  },
  {
    href: "/settings/integrations",
    subItems: [
      { name: "外部プラットフォーム連携", href: "/settings/integrations" },
    ],
  },
]
